import React from "react";
import "../../css/components/auroraBackground.css";

/**
 * AuroraBackground - Reusable animated nebula background with floating particles
 * 
 * 
 * Props:
 * @param {number} particleCount - Number of floating particles (default: 8, supports up to 12)
 * @param {string} className - Optional additional CSS class for customization
 */
export const AuroraBackground = ({ particleCount = 8, className = "" }) => {
  return (
    <>
      {/* Floating particles */}
      <div className={`aurora-particles ${className}`}>
        {Array.from({ length: particleCount }).map((_, index) => (
          <div key={index} className="aurora-particle"></div>
        ))}
      </div>
    </>
  );
};


